import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { AlertHandler } from 'src/app/core/handlers/alert-handler';
import { Scenario } from 'src/app/core/models/scenario';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { MondelezService } from 'src/app/shared/services/mondelez.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-map-view-filter',
  templateUrl: './map-view-filter.component.html',
  styleUrls: ['./map-view-filter.component.scss'],
})
export class MapViewFilterComponent implements OnInit, OnDestroy {
  @Input() showClearFilter = false;
  public defaultSelection: any;
  public filterForm: FormGroup;
  public node_id: number;
  public node_type: string;
  public location: string;
  public masterFilterData: any[] = [];
  public initialFiltersValues: any = {};
  public supplyMode: any;
  public mapViewFilters = {
    geography: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    node_code: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
  };
  public scenarioId: number;

  private iteration_code: number;
  private subs = new Subscription();
  @ViewChild('allSelectedGeography') public allSelectedGeography: MatOption;

  constructor(private globalFilterService: GlobalFilterService, private mondelezDataService: MondelezDataService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.mondelezDataService.supplyMode.subscribe((value) => {
      this.supplyMode = value;
    });
    this.createForm();
    this.subs.add(
      this.mondelezDataService.currentScenarioChanged.subscribe((scenario: Scenario) => {
        if (scenario && scenario.scenario_id) {
          this.scenarioId = scenario.scenario_id;
          this.iteration_code = scenario.iteration_code;
          this.fetchMapViewFiltersData();
        }
      })
    );
    _.each(this.mapViewFilters, (value, key) => {
      this.mapViewFilters[key].filterCtrl.valueChanges.subscribe(() => {
        this.filterFilters(key, this.mapViewFilters);
      });
    });
    this.subs.add(
      this.globalFilterService.mapViewFilters.subscribe((value: any) => {
        if (value) {
          this.defaultSelection = value;
          this.filterForm.patchValue({ ...value });
          this.setIdTypeLocationValues('node_code');
          this.applyFilter();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.onClearFilter();
  }

  createForm() {
    this.filterForm = this.fb.group({
      geography: [this.defaultSelection?.geography],
      node_code: [this.defaultSelection?.node_code],
    });
  }

  onClearFilter(): void {
    this.filterForm.reset();
    this.filterForm.patchValue({ geography: this.defaultSelection.geography });
    this.filterForm.patchValue({ node_code: this.defaultSelection.node_code });
    this.globalFilterService.updateMapViewFiltersSelection(this.filterForm.value);
    this.initFilterData(this.masterFilterData, this.mapViewFilters);
  }

  fetchMapViewFiltersData(): void {
    if (this.globalFilterService.getFilterMasterData().node_master) {
      this.masterFilterData =
        this.supplyMode == 'manufacturing' ? this.globalFilterService.getFilterMasterData().plant_master : this.globalFilterService.getFilterMasterData().node_master;
      this.initFilterData(this.masterFilterData, this.mapViewFilters);
    } else {
      AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
    }
    // this.subs.add(
    //   this.mondelezService.fetchFilterData().subscribe({
    //     next: (result: any) => {
    //       if (result && result.response === 'SUCCESS') {
    //         this.masterFilterData = result.filters_data;
    //         this.initFilterData(this.masterFilterData, this.mapViewFilters);
    //       } else {
    //         alert(MessageHandler.INTERNAL_ERROR);
    //       }
    //     },
    //     error: (error) => {
    //       alert(MessageHandler.INTERNAL_ERROR);
    //     },
    //   })
    // );
  }

  initFilterData(data, filters): void {
    _.each(filters, (value, key) => {
      if (key !== '') {
        let dataList;
        dataList = _.sortBy(_.uniq(_.pluck(data, key)));
        filters[key].values = dataList;
        filters[key].filtered.next(dataList.slice());
      }
    });
  }

  protected filterFilters(field, filters) {
    if (!filters[field].values) {
      return;
    }
    // get the search keyword
    let search = filters[field].filterCtrl.value;
    if (!search) {
      filters[field].filtered.next(filters[field].values.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filters[field].filtered.next(filters[field].values.filter((el) => el.toLowerCase().indexOf(search) > -1));
  }

  handleOpenedChange(isOpened, formFiled) {
    if (isOpened) {
      this.setInitialFilterFormValues(formFiled);
    } else {
      if (this.initialFiltersValues.hasOwnProperty(formFiled)) {
        const initialValue = this.initialFiltersValues[formFiled];
        const currentValue = this.filterForm.controls[formFiled].value;
        if ((initialValue === null && (currentValue === null || (Array.isArray(currentValue) && currentValue.length === 0))) === false) {
          const valueChanged = this.isValueChanged(initialValue, currentValue);
          if (valueChanged) {
            this.globalFilterService.updateMapViewFiltersSelection(this.filterForm.value);
            this.applyFilter();
            if (formFiled === 'node_code') {
              this.setIdTypeLocationValues(formFiled);
            }
          }
        }
      }
    }
  }

  setInitialFilterFormValues(formFiled) {
    this.initialFiltersValues[formFiled] = this.filterForm.controls[formFiled].value;
  }

  isValueChanged(initialValue: any, currentValue: any): boolean {
    if (Array.isArray(initialValue) && Array.isArray(currentValue)) {
      if (initialValue.length !== currentValue.length) {
        return true;
      } else {
        return !initialValue.every((element) => {
          if (currentValue.includes(element)) {
            return true;
          }
          return false;
        });
      }
    } else {
      return initialValue !== currentValue;
    }
  }

  applyFilter() {
    const geography = this.filterForm.value['geography'] || [];
    const node_code = this.filterForm.value['node_code'] || [];
    let filters: any = [];
    let keys: any = [];
    let masterData: any = [];
    filters = [
      { key: 'geography', values: geography },
      { key: 'node_code', values: node_code },
    ];
    keys = ['geography', 'node_code'];
    masterData = JSON.parse(JSON.stringify(this.masterFilterData));

    keys.forEach((key) => {
      const temp = masterData.filter((item) => {
        return filters
          .filter((filter) => filter.key !== key)
          .every((filter) => {
            if (filter.values.length === 0) return true;
            return filter.values.includes(item[filter.key]);
          });
      });
      const uniqueValues = _.sortBy(_.uniq(this.getKeysfilter(key, JSON.parse(JSON.stringify(temp)))));
      this.mapViewFilters[key].filtered.next(uniqueValues);
    });
  }

  getKeysfilter(key, data): any {
    return data.map((ele) => ele[key]);
  }

  toggleAllSelection(formField, selectAllOption): void {
    let mapViewFilters: any;
    mapViewFilters = this.mapViewFilters;
    if (selectAllOption.selected) {
      let allOptions = [];
      mapViewFilters[formField].filtered.subscribe((res) => {
        allOptions = res;
      });
      let newValues = allOptions.map((item) => {
        return item;
      });
      newValues.push('');
      const temp = this.filterForm.get(formField);
      temp.patchValue([...newValues]);
    } else {
      const temp = this.filterForm.get(formField);
      temp.patchValue([]);
    }
  }

  togglePerOne(formField, selectAllOption) {
    let mapViewFilters: any;
    mapViewFilters = this.mapViewFilters;
    if (selectAllOption.selected) {
      selectAllOption.deselect();
      return false;
    }
    const temp = this.filterForm.get(formField);
    let allOptions = [];
    mapViewFilters[formField].filtered.subscribe((res) => {
      allOptions = res;
    });
    if (temp.value && temp.value.length == allOptions.length) selectAllOption.select();
    return '';
  }

  setIdTypeLocationValues(key: any): void {
    const selectedName = this.filterForm.get(key).value;
    if (selectedName) {
      const location = this.masterFilterData.filter((item) => item[key] === selectedName);
      if (location.length > 0) {
        this.node_id = location[0].node_id || null;
        this.node_type = location[0].node_type || null;
        this.location = location[0].location || null;
      }
    } else {
      this.node_id = null;
      this.node_type = null;
      this.location = null;
    }
  }
}
